import { getAccessToken } from "./utils";
import { getUrl, getAuthUrls } from "./urls";
import axios from "axios";

import { toast } from "react-toastify";
import {
    SIGN_IN,
    SIGN_OUT,
    SIGN_UP,
    FORGET_PASS,
    RESET_PASS,
    FACEBOOK_LOGIN,
    LINKEDIN_LOGIN,
    GOOGLE_LOGIN,
    SEND_OTP,
    SET_OTP_SENT,
    EMAIL_VERIFY,
} from "../reducers/authReducer";

// export const SIGN_IN = "SIGN_IN";
// export const SIGN_OUT = "SIGN_OUT";
// export const SIGN_UP = "SIGN_UP";
// export const RESET_PASS = "RESET_PASS";
// export const FORGET_PASS = "FORGET_PASS";
// export const CLOSE_LOADER = "CLOSE_LOADER";
// export const EMAIL_VERIFY = "EMAIL_VERIFY";
// export const FACEBOOK_LOGIN = "FACEBOOK_LOGIN";
// export const LINKEDIN_LOGIN = "LINKEDIN_LOGIN";
// export const GOOGLE_LOGIN = "GOOGLE_LOGIN";
// export const SEND_OTP = "SEND_OTP";
// export const SET_OTP_SENT = "SET_OTP_SENT";

export const signIn = (data) => {
    // let url = `https://api2.radarr.com/auth-service/login`;
    const url = getAuthUrls("sign_in");
    let req = axios({
        method: "post",
        url,
        data,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            if (err?.response?.data && err?.response?.data?.message) toast.error(err?.response?.data?.message);
            else toast.error("Some Error Occured.");
            return err;
        });

    return {
        type: SIGN_IN,
        payload: req,
    };
};

export const send2FAOTP = (data) => {
    // let url = `https://api2.radarr.com/auth-service/2fa/otp/generate`;
    const url = `${getAuthUrls("auth_service")}/2fa/otp/generate`;
    let req = axios({
        method: "post",
        url,
        data,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            if (err?.response?.data && err?.response?.data?.message) toast.error(err?.response?.data?.message);
            else toast.error("Some Error Occured.");
            return err;
        });

    return {
        type: "2FA_OTP",
        payload: req,
    };
};

export const signOutAuth = (access_token) => {
    // let url = `https://api2.radarr.com/auth-service/logout`;
    const url = `${getAuthUrls("auth_service")}/logout`;
    let data = { access_token };
    let req = axios({
        method: "post",
        url,
        data,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            return err;
        });

    return {
        type: "SIGN_OUT",
        payload: req,
    };
};

export const signOut = () => {
    return {
        type: "SIGN_OUT",
    };
};

// export const signUp = (data) => {
//     let url = `https://api2.radarr.com/auth-service/signup`;
//     let res = axios({
//         method: "post",
//         url: url,
//         data: data,
//         headers: {
//             "Content-Type": "application/json",
//         },
//     })
//         .then((resp) => {
//             toast.success(resp.data.data.message);
//             return resp.data;
//         })
//         .catch((err) => {
//             toast.error(err.response.data.message);
//             throw err;
//         });
//     return {
//         type: SIGN_UP,
//         payload: res,
//     };
// };

export const sendOTP = (data) => {
    // let url = `https://api2.radarr.com/auth-service/send-email-verification-otp`;
    const url = `${getAuthUrls("auth_service")}/send-email-verification-otp`;

    let res = axios({
        method: "post",
        url,
        data,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            // console.log(res.data.data);
            // toast.success(res.data.data.message);
            return res.data;
        })
        .catch((err) => {
            // toast.error(err.response.data.message);
            return err.response;
        });

    return {
        type: SEND_OTP,
        payload: res,
    };
};

export const setOTPSent = () => {
    return {
        type: SET_OTP_SENT,
    };
};

export const verifyOTP = (data) => {
    // let url = `https://api2.radarr.com/auth-service/email-otp-verify`;
    const url = `${getAuthUrls("auth_service")}/email-otp-verify`;

    let res = axios({
        method: "post",
        url,
        data,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            // console.log(res.data.data);
            // toast.success(res.data.data.message);
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });

    return {
        type: "VERIFY_OTP",
        payload: res,
    };
};

export const signUp = (data) => {
    // let url = `https://api2.radarr.com/auth-service/v2/signup`;
    const url = `${getAuthUrls("auth_service")}/v2/signup`;

    let res = axios({
        method: "post",
        url,
        data,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            // console.log(res);
            // toast.success(res.data.data.message);
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });

    return {
        type: EMAIL_VERIFY,
        payload: res,
    };
};

export const resetPassword = (data) => {
    // let url = `https://api2.radarr.com/auth-service/reset-password`;
    const url = `${getAuthUrls("reset_password")}`;

    let res = axios({
        method: "post",
        url: url,
        data: data,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((resp) => {
            toast.success(resp.data.data.message);
            return resp.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: RESET_PASS,
        payload: res,
    };
};

export const forgetPassword = (data) => {
    // let url = `https://api2.radarr.com/auth-service/forget-password`;
    const url = `${getAuthUrls("forget_password")}`;
    let res = axios({
        method: "post",
        url: url,
        data: data,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((resp) => {
            toast.success(resp.data.data.message);
            return resp.data.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: FORGET_PASS,
        payload: res,
    };
};
export const emailVerify = (data) => {
    // let url = `https://api2.radarr.com/auth-service/email-verification?token=` + data.token;
    const url = `${getAuthUrls("email_verify")}?token=${data.token}`;

    let res = axios({
        method: "get",
        url: url,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((resp) => {
            toast.success(resp.data.data.message);
            return resp.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            throw err;
        });
    return {
        type: EMAIL_VERIFY,
        payload: res,
    };
};
export const facebookLogin = (data) => {
    // const url = `https://api2.radarr.com/auth-service/oauth`;
    const url = `${getAuthUrls("socialLogin")}`;

    let res = axios({
        url: url,
        method: "post",
        data: data,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            toast.success(res.data.data.message);
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err;
        });
    return {
        type: FACEBOOK_LOGIN,
        payload: res,
    };
};

export const linkedinLogin = (param) => {
    // const url = `https://api2.radarr.com/auth-service/oauth`;
    const url = `${getAuthUrls("socialLogin")}`;

    let res = axios({
        url: url,
        method: "post",
        data: param,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            toast.success(res.data.data.message);
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err;
        });
    return {
        type: LINKEDIN_LOGIN,
        payload: res,
    };
};

export const googleLogin = (param) => {
    // console.log("firstffff", param);
    // const url = `https://api2.radarr.com/auth-service/oauth`;
    const url = `${getAuthUrls("socialLogin")}`;

    let res = axios({
        url: url,
        method: "post",
        data: param,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            toast.success(res.data.data.message);
            // console.log(res.data);
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err;
        });
    return {
        type: GOOGLE_LOGIN,
        payload: res,
    };
};

//gmb_get_token

export const getGMBToken = (param) => {
    const url = getUrl("gmb_get_token");
    let res = axios({
        url: url,
        method: "post",
        data: param,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            toast.success(res.data.data.message);

            return res.data;
        })
        .catch((err) => {
            // toast.error(err.response.data.message);
            return err.response;
        });
    return {
        type: "GET_GMB_TOKEN",
        payload: res,
    };
};

export const getYoutubeToken = (param) => {
    const url = getUrl("youtube_get_token");
    let res = axios({
        url: url,
        method: "post",
        data: param,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            // toast.success(res.data.data.message);
            return res.data;
        })
        .catch((err) => {
            // toast.error(err.response.data.message);
            return err.response;
        });
    console.log("doneeeee");
    return {
        type: "GET_YOUTUBE_TOKEN",
        payload: res,
    };
};

export const getGMBAccount = (data) => {
    const url = `https://mybusiness.googleapis.com/v1/accounts`;
    let res = axios({
        method: "get",
        url: url,
        headers: {
            Authorization: `Bearer ${data.token} `,
            "Content-Type": "application/json",
        },
    })
        .then((resp) => {
            // toast.success(resp.data.data.message);
            return resp.data;
        })
        .catch((err) => {
            toast.error(err.response?.data?.message);
            return err.responser;
        });
    return {
        type: "GET_GMB_ACCOUNT",
        payload: res,
    };
};

export const getYoutubeAccount = (data) => {
    const url = `https://www.googleapis.com/youtube/v3/channels?maxResults=50&mine=true&part=id,snippet,statistics`;
    let res = axios({
        method: "get",
        url: url,
        headers: {
            Authorization: `Bearer ${data.token} `,
            "Content-Type": "application/json",
        },
    })
        .then((resp) => {
            // toast.success(resp.data.data.message);
            return resp.data;
        })
        .catch((err) => {
            toast.error(err.response?.data?.message);
            return err.responser;
        });
    return {
        type: "GET_YOUTUBE_ACCOUNT",
        payload: res,
    };
};

export const getGMBLocation = (data) => {
    let promises = [];

    data.data.id.forEach((ele, i) => {
        promises.push(
            axios({
                method: "get",
                url: `https://mybusiness.googleapis.com/v1/${ele}/locations?pageSize=100&readMask=name,title,storefrontAddress`,
                headers: {
                    Authorization: `Bearer ${data.token} `,
                    "Content-Type": "application/json",
                },
            }).then((r) => ({ accountID: ele, accountName: data.data.name[i], data: r.data })),
        );
    });

    let req = Promise.all(promises)
        .then((resp) => {
            // toast.success(resp.data?.data.message);
            return resp;
        })
        .catch((err) => {
            toast.error(err.response?.data.message);
            throw err;
        });

    return {
        type: "GET_GMB_LOCATION",
        payload: req,
    };
};

export const getYoutubeStoreToken = (param) => {
    const url = getUrl("youtube_get_store_token");
    let res = axios({
        url: url,
        method: "post",
        data: param,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            toast.success("Authentication Successful");

            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err.response;
        });
    return {
        type: "GET_YOUTUBE_STORE_TOKEN",
        payload: res,
    };
};

export const getGMBStoreToken = (param) => {
    const url = getUrl("gmb_get_store_token");
    let res = axios({
        url: url,
        method: "post",
        data: param,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            toast.success("Authentication Successful");

            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err.response;
        });
    return {
        type: "GET_GMB_STORE_TOKEN",
        payload: res,
    };
};

export const getPlayStoreToken = (param) => {
    const url = getUrl("token_service_playstore");
    let res = axios({
        url: `${url}/access_token`,
        method: "post",
        data: param,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
        },
    })
        .then((res) => {
            toast.success(res.data.data?.message);

            return res.data;
        })
        .catch((err) => {
            // toast.error(err.response.data.message);
            return err.response;
        });
    return {
        type: "GET_PLAY_STORE_TOKEN",
        payload: res,
    };
};
export const setPlayStoreClientDetails = (payload) => {
    return {
        type: "SET_PLAYSTORE_CLIENT_DETAILS",
        payload,
    };
};

export const validatePlaystorePackage = (param) => {
    const url = getUrl("token_service_playstore");
    let res = axios({
        url: `${url}/package`,
        method: "post",
        data: param,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
        },
    })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err.response;
        });
    return {
        type: "VALIDATE_PLAYSTORE_PACKAGE",
        payload: res,
    };
};

export const storePlayStoreToken = (param) => {
    const url = getUrl("token_service_playstore");
    let res = axios({
        url: `${url}/store-token`,
        method: "post",
        data: param,
        headers: {
            "Content-Type": "application/json",
            "access-token": getAccessToken(),
        },
    })
        .then((res) => {
            toast.success("Authentication Successful");

            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err.response;
        });
    return {
        type: "STORE_PLAYSTORE_STORE_TOKEN",
        payload: res,
    };
};

export const validateAppstoreToken = async (params) => {
    try {
        const url = `${getUrl("appstore_token")}/package`;
        const res = await axios({
            url,
            method: "post",
            data: params,
            headers: {
                "Content-Type": "application/json",
                "access-token": getAccessToken(),
            },
        });

        return res.data;
    } catch (error) {
        // toast.error(error.response?.data?.message);
        return null;
    }
};

export const storeAppstoreToken = async (params) => {
    try {
        const url = `${getUrl("appstore_token")}/store-token`;

        const res = await axios({
            url,
            method: "post",
            data: params,
            headers: {
                "Content-Type": "application/json",
                "access-token": getAccessToken(),
            },
        });
        toast.success("Authentication Successful");

        return res.data;
    } catch (error) {
        toast.error(error.response?.data?.message);
        return null;
    }
};

export const validateTelegramToken = async (params) => {
    try {
        const url = `${getUrl("telegram_token")}/bot_token`;
        const res = await axios({
            url,
            method: "post",
            data: params,
            headers: {
                "Content-Type": "application/json",
                "access-token": getAccessToken(),
            },
        });

        return res.data;
    } catch (error) {
        return null;
    }
};

export const storeTelegramToken = async (params) => {
    try {
        const url = `${getUrl("telegram_token")}/store-token`;

        const res = await axios({
            url,
            method: "post",
            data: params,
            headers: {
                "Content-Type": "application/json",
                "access-token": getAccessToken(),
            },
        });
        toast.success("Authentication Successful");

        return res.data;
    } catch (error) {
        toast.error(error.response?.data?.message);
        return null;
    }
};
